export const getDaySuffix = (day: number) => {
  if (day > 3 && day < 21) return 'th';

  const suffixByLastDigit = new Map([
    [1, 'st'],
    [2, 'nd'],
    [3, 'rd'],
  ]);

  return suffixByLastDigit.get(day % 10) ?? 'th';
};
